import {
  FetchArticleLikes,
  FetchMediaLikes,
} from '../../api/queries/likes.gql';

const LIKEQUERY = {
  media: FetchMediaLikes,
  article: FetchArticleLikes,
};

export default LIKEQUERY;
